import { useNavigate } from 'react-router-dom';
import type {
    FindingPlanumDocType,
    FindingProfileDocType
} from '@ast-data/shared';
import FindingDescriptionList from '../findings/FindingDescriptionList';

/**
 * The Planum/Profil descriptions shown inside a Befund card on the field Befunde
 * list — the shared grouped list, wired to the field editor routes with a plain
 * navigate (the card carries no unsaved form state to guard).
 */
export default function FieldFindingCardDescriptions({
    projectId,
    findingId,
    planums,
    profiles
}: {
    projectId: string;
    findingId: string;
    planums: FindingPlanumDocType[];
    profiles: FindingProfileDocType[];
}) {
    const navigate = useNavigate();
    return (
        <FindingDescriptionList
            projectId={projectId}
            planums={planums}
            profiles={profiles}
            basePath={`/field/${projectId}/findings/${findingId}`}
            onNavigate={navigate}
        />
    );
}
